/**
 * 이용약관 (Terms of Service) - 한국어 v1
 * 
 * 원본: public/terms.html (Pi Network 공식 제출본)
 * 한국어 번역본
 */
export const TERMS_V1_KO = {
    version: "v1",
    effectiveDate: "2025-10-15",
    language: "ko",
    title: "이용약관",
    content: `
Spot Go 이용약관

최종 업데이트: 2025년 10월 15일 (KST)

본 이용약관("약관")은 개발자("당사", "우리")가 제공하는 Spot Go 게임("서비스")의 이용에 관한 사항을 규정합니다. 서비스에 접속하거나 이용함으로써 귀하는 본 약관에 동의하게 됩니다.

1. 계정

귀하의 계정은 Pi Network 신원에 연결됩니다. 귀하는 본 약관 준수를 포함하여 귀하의 계정에서 발생하는 모든 활동에 대해 책임을 집니다.

1-1. 닉네임의 공개 표시 및 저장

귀하의 Pi Network 닉네임과 사용자 ID는 Pi Network 로그인 과정을 통해 수신되어 당사 서버에 안전하게 저장됩니다. 이러한 식별자는 귀하의 계정을 유지하고, 랭킹(예: 리더보드 및 이벤트)을 표시하며, 결제 내역을 확인하는 데 사용됩니다. 귀하의 닉네임은 서비스 내 다른 사용자에게 공개적으로 표시될 수 있습니다. 다른 개인 정보나 결제 정보는 다른 플레이어와 공유되지 않습니다.

2. 가상 재화

서비스에는 가상 재화("가상 재화")가 포함될 수 있습니다. 이는 실제 화폐가 아닙니다. 관련 법률에서 요구하는 경우를 제외하고, 가상 재화의 모든 구매는 최종적이며 환불되지 않습니다. 당사는 통지 여부와 관계없이 언제든지 가상 재화를 관리, 규제, 통제, 수정 또는 제거할 절대적인 권리를 가집니다. 당사가 이러한 권리를 행사하더라도 귀하 또는 제3자에 대해 책임을 지지 않습니다.

3. 사용자 행동

귀하는 서비스를 오용하지 않기로 동의합니다. 여기에는 치팅, 버그 악용, 자동화 소프트웨어(봇) 사용, 소프트웨어 디컴파일, 서비스 무결성 파괴 시도가 포함되며 이에 국한되지 않습니다.

4. 지적재산권

서비스(모든 콘텐츠, 기능, 기술 포함)는 개발자의 독점 재산입니다. 귀하에게는 개인적, 비상업적 용도로 서비스에 접속하고 이용할 수 있는 제한적이고 비독점적이며 양도 불가능한 라이선스가 부여됩니다.

5. 해지

귀하가 약관을 위반하는 경우 당사는 사전 통지나 책임 없이 즉시 서비스 접근을 해지하거나 정지할 수 있습니다. 접근 해지 시 서비스와 관련된 모든 게임 데이터가 즉시 영구적으로 삭제됩니다.

6. 보증 부인; 책임 제한

서비스는 "있는 그대로" 및 "이용 가능한 상태로" 제공됩니다. 법률이 허용하는 최대 범위 내에서 당사는 모든 종류의 보증을 부인합니다. 법률이 허용하는 최대 범위 내에서 개발자는 귀하의 서비스 이용 또는 이용 불능으로 인한 간접적, 부수적, 특별, 결과적 또는 징벌적 손해에 대해 책임을 지지 않습니다.

7. 준거법 및 분쟁 해결

본 약관은 법률 충돌 조항에 관계없이 대한민국 법률에 의해 규율됩니다. 본 약관과 관련하여 발생하는 모든 분쟁은 수원지방법원의 전속 관할에 따릅니다.

8. 약관 변경

당사는 언제든지 본 약관을 수정할 권리를 보유합니다. 변경 사항은 서비스 내 또는 공식 웹사이트에 새로운 약관을 게시함으로써 통지됩니다.

9. 문의하기

질문이 있으시면 다음으로 연락해 주세요: lukep81@painori.com
`.trim()
};
